import {Component, Input, OnInit} from '@angular/core';

export interface EmissionsBoxStepItem {
  value: number;
  legend: string;
}

@Component({
  selector: 'app-emissions-box-informative',
  templateUrl: './emissions-box-informative.component.html',
  styleUrls: ['./emissions-box-informative.component.scss']
})
export class EmissionsBoxInformativeComponent implements OnInit {

  @Input() title: string;
  @Input() subtitleLegend: string = 'kWh';
  @Input() stepTotalEmissions: number;
  @Input() stepItems: EmissionsBoxStepItem[];
  @Input() totalEmissions: number;
  @Input() enablePositionFixed: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  get resolvedStepItems(): EmissionsBoxStepItem[] {
    if (this.stepItems !== undefined) {
      return this.stepItems;
    }
    return [{value: this.stepTotalEmissions, legend: this.subtitleLegend}];
  }

}
